var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperadmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 8,
    r: 4.75,
    "data-original": "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21 12.81-1.09-1.09a1.97 1.97 0 0 0-2.78 0l-4.02 4.02c-.28.28-.47.64-.54 1.02l-.58 3.09c-.05.24.03.5.21.67.14.14.33.22.53.22.05 0 .09 0 .14-.01l3.09-.58c.39-.07.74-.26 1.02-.54L21 15.59c.77-.77.77-2.01 0-2.78zm-9.91 3.68c.13-.69.46-1.31.96-1.81l.43-.43H8.01c-2.58 0-4.82 1.75-5.44 4.25l-.29 1.18c-.06.22 0 .46.14.64s.36.29.59.29h7.55c-.09-.33-.12-.68-.05-1.02l.59-3.1z",
    "data-original": "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperadmin);
export default __webpack_public_path__ + "static/media/superadmin.6c59e8b74707c92fdd56b05a5c9dc96f.svg";
export { ForwardRef as ReactComponent };